import { Typography } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

interface Props {
  userName: Maybe<string>;
}

function TopBar({ userName }: Props) {
  return (
    <>
      <div className="flex">
        <Typography variant="h5" className="mb-3" color="dark">
          <T
            kind="Hello <span>{{name}}</span>"
            span={(content) => <span className="font-bold">{content},</span>}
            name={userName.getOrElseValue('Administrator')}
          />
        </Typography>
      </div>
      <T kind="Here's a snapshot of what’s been happening in your organization." />
    </>
  );
}

export default observer(TopBar);
